import('./bootstrap').catch(e => {
  // eslint-disable-next-line no-console
  console.error('Could not bootstrap App for SMaterials', e);
});

export {};
